<template>
  <div class="manager_dashboard">
  <user-menu />
  <div class="wrapper">
    <!-- <admin-sidebar-menu v-if="admin" /> -->
    <div class="content-wrapper">
      <div class="container-wrapper center">
        <div>
          <h3 class="d-inline heading"> Tasks - <router-link :to="'/view-mentee-profile/' + menteeId" class="menteeName">{{ menteeName }}</router-link></h3>
        </div>
        <div class="heading-seperator"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div v-if="loading === false">

          <div class="row mt-2">
            <div class="col-9 col-sm-9 col-md-9 col-lg-9 col-xl-7">               
              
                
                  <div v-if="tasklists.length > 0">
                    <b-form-select v-model="tasklistId" :options="tasklists" style="margin-bottom: 0px !important" class="mb-3 col-md-12" @change="onchangeTasklists()" />
                  </div>
                </div>
                <div class="col-2 col-sm-4 col-md-3 col-lg-2 col-xl-1 p-0">
               
                  <button class="btn btn-primary btn-sm task-goal-btn" @click="redirectTaskGoal">Task Goals</button>
                  
                </div>

                <div class="col-2 col-sm-4 col-md-3 col-lg-2 col-xl-1 p-0">
                            <div :class="(repCount == 0) ? 'goReview goReview-0' : 'goReview'" >
                              <div class="review_count">{{ repCount }}</div>

                              <div v-if="repCount > 1" class="review_text">Reps to <br/> Review</div>
                              <div v-else-if="repCount == 1" class="review_text">Rep to <br/> Review</div>
                              <div v-else class="review_text">Reps to <br/> Review</div>
                              <div class="goReviewBtn" v-if="repCount > 0" v-on:click="menteeRepititionApproval" >
                                <button class="col-12 p-0 btn btn-primary btn-sm goRepsBtn" >Go</button>
                              </div>
                  </div>
                </div>

                               
                <div class="col-2 col-sm-4 col-md-3 col-lg-2 col-xl-3">
                  <input type="text" v-model="searchText" placeholder="Search task(s)" class="search-tasks" @keyup.enter="dosearch()"/>
                  <i class="fa fa-search search-icon" @click="dosearch()" aria-hidden="true" ></i>
                </div>
           
          </div>
          
          <div class="col-12 p-0 text-right" style="padding-right: 28px !important;" v-if="searchTextFlag == true">
            <button class="btn btn-grey btn-sm clear-button" @click="clearText()" >Clear</button>
          </div>

          <flash-message autoHide variant="success"></flash-message>

    <!-- Focused Section display -->
         <div v-if="focusedSubtasks.length > 0">
           <div class="section-title">
              Focused Sections
           </div>
           <div class="heading-seperator" style="margin-top: 0;"></div>
         </div>
             
          <div v-show="tasklists_loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <div v-if="focusedSubtasks.length > 0" class="col-md-12 counter_subtask-list" style="    margin-top: 10px;">
              <div v-for = "(focusedSubtask, fsindex) in focusedSubtasks">
                <div class="subtask-wrapper">
                <h4 class="panel-title focused-section-highlight">
                  <div class="col-12 p-0 float-left">
                    <div class="float-left col-4 p-0">
                      <b-link
                        v-b-toggle="'collapse-focused-' + focusedSubtask.id" @click="getSecondFontIcon(focusedSubtask.id)" style="min-height: 44px;"
                        >
                          {{ focusedSubtask.name }}
                      </b-link>
                    </div>
                    
                   <div class="float-left col-6" style="text-align: left; padding: 0px 0px 0px 0px;" v-if="focusedSubtask.id != 99999">
                      <b-link
                        v-b-toggle="'collapse-focused-' + focusedSubtask.id" @click="getSecondFontIcon(focusedSubtask.id)" style="height: 44px; float: left; width: 100%;"
                        >
                      <div class="float-left progress  p-0" style="margin-right: 20px;">
                        <div class="progress-bar-green" :style="'width: ' + focusedSubtask.subtaskCompetentPercent + '%;'" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <div class="float-left col-2 p-0 progress-text">{{ focusedSubtask.subtaskCompetentPercent }}%</div>
                      </b-link>
                    </div>
                    <div class="float-left col-6 p-0" v-if="focusedSubtask.id == 99999" style="padding: 7px 10px 10px 20px  !important;">
                      <button class="btn btn-primary btn-sm dbAddRepsBtn1" @click="openAddOtherTasksModal('focused')">
                        Add Tasks
                    </button>
                    </div>
                    <div class="float-left col-1 p-0" style="text-align: right !important; padding: 0px 0px 0px 0px !important; " >
                      <b-link
                        v-b-toggle="'collapse-focused-' + focusedSubtask.id" class="p-0" @click="getFocusedSecondFontIcon(focusedSubtask.id)" v-if="selectedSubtask != '' && focusedSubtask.id == selectedSubtask && clickedFrom=='focused'" style="padding: 10px !important; height: 44px;">
                        <i class="fa fa-angle-up angle-class" :id="'angle-focused-'+ focusedSubtask.id" aria-hidden="true" ></i>
                      </b-link>

                      <b-link
                        v-b-toggle="'collapse-focused-' + focusedSubtask.id" class="p-0" @click="getFocusedSecondFontIcon(focusedSubtask.id)" style="padding: 10px !important; height: 44px;" v-else>
                        <i class="fa fa-angle-down angle-class" :id="'angle-focused-'+ focusedSubtask.id" aria-hidden="true" ></i>
                      </b-link>
                    </div>

                    <div class="float-right col-1 p-0 star-class" v-if="focusedSubtask.id != 99999">
                      <i class="fa fa-star"  aria-hidden="true"  @click="removeFocusedSection(focusedSubtask.focusedSectionId)" data-toggle="tooltip" data-placement="bottom" title="Remove from Focused Section" style="cursor: pointer; color: #ee4200;"></i>
                    </div>
                    </div>
                    
                    <div style="clear: both;"></div> 
                   </h4>

                <b-collapse v-bind:id="'collapse-focused-' + focusedSubtask.id" class="mt-2 subtask-wrapper" visible v-if="selectedSubtask != '' && focusedSubtask.id == selectedSubtask && clickedFrom=='focused'">
                  <b-card>
                    <div class="col-md-12 override-padding counter_heading-list">
                      <div v-for = "(focusedHeading, hindex) in focusedSubtask.headings">
                        <b-link v-b-toggle="'collapse-focused-' + focusedSubtask.id + '-' + focusedHeading.id"  variant="primary" size="sm" class="sub-heading" @click="getFocusedFontIcon(focusedSubtask.id + '-' + focusedHeading.id)" v-if="selectedHeading != '' && focusedHeading.id == selectedHeading && clickedFrom=='focused'">
                          {{ focusedHeading.name }}
                          <i class="fa fa-angle-up" :id="'angle-focused-'+ focusedSubtask.id + '-' + focusedHeading.id" aria-hidden="true"></i>
                        </b-link>

                        <b-link v-b-toggle="'collapse-focused-' + focusedSubtask.id + '-' + focusedHeading.id"  variant="primary" size="sm" class="sub-heading" @click="getFocusedFontIcon(focusedSubtask.id + '-' + focusedHeading.id)" v-else>
                          {{ focusedHeading.name }}
                          <i class="fa fa-angle-down" :id="'angle-focused-'+ focusedSubtask.id + '-' + focusedHeading.id" aria-hidden="true"></i>
                        </b-link>

                        <b-collapse v-bind:id="'collapse-focused-' + focusedSubtask.id + '-' + focusedHeading.id" class="mt-2 task-wrapper" visible v-if="selectedHeading != '' && focusedHeading.id == selectedHeading && clickedFrom=='focused'">
                          <div class="col-md-12 override-padding counter_task-list">
                            <MenteeTaskList
                                :itemLength="focusedHeading.tasks.length" 
                                :allItems="focusedHeading.tasks"
                                :menteeId="menteeId"
                                :tasklistId="tasklistId"
                                :subTaskId="focusedSubtask.id"
                                :headingId="focusedHeading.id"
                                :searchText="searchText"
                                originFrom="focused">
                            </MenteeTaskList>
                            <div style="clear: both;"></div>
                          </div>
                        </b-collapse>

                        <b-collapse v-bind:id="'collapse-focused-' + focusedSubtask.id + '-' + focusedHeading.id" class="mt-2 task-wrapper" v-else>
                          <div class="col-md-12 override-padding counter_task-list">
                            <MenteeTaskList
                                :itemLength="focusedHeading.tasks.length" 
                                :allItems="focusedHeading.tasks"
                                :menteeId="menteeId"
                                :tasklistId="tasklistId"
                                :subTaskId="focusedSubtask.id"
                                :headingId="focusedHeading.id"
                                :searchText="searchText"
                                originFrom="focused">
                            </MenteeTaskList>
                            <div style="clear: both;"></div>
                          </div>
                        </b-collapse>

                      </div>
                    </div>
                    <div class="col-md-12 override-padding counter_task-list task-wrapper">
                      <MenteeTaskList
                          :itemLength="focusedSubtask.tasks.length" 
                          :allItems="focusedSubtask.tasks"
                          :menteeId="menteeId"
                          :tasklistId="tasklistId"
                          :subTaskId="focusedSubtask.id"
                          headingId=""
                          :searchText="searchText"
                          originFrom="focused">
                      </MenteeTaskList>
                    </div>
                    <div style="clear: both;"></div>
                  </b-card>
                </b-collapse>

                 <b-collapse v-bind:id="'collapse-focused-' + focusedSubtask.id" class="mt-2 subtask-wrapper" v-else>
                  <b-card>
                    <div class="col-md-12 override-padding counter_heading-list">
                      <div v-for = "(focusedHeading, hindex) in focusedSubtask.headings">
                        <b-link v-b-toggle="'collapse-focused-' + focusedSubtask.id + '-' + focusedHeading.id"  variant="primary" size="sm" class="sub-heading" @click="getFocusedFontIcon(focusedSubtask.id + '-' + focusedHeading.id)">
                          {{ focusedHeading.name }}
                          <i class="fa fa-angle-down" :id="'angle-focused-'+ focusedSubtask.id + '-' + focusedHeading.id" aria-hidden="true"></i>
                        </b-link>
                        <b-collapse v-bind:id="'collapse-focused-' + focusedSubtask.id + '-' + focusedHeading.id" class="mt-2 task-wrapper">
                          <div class="col-md-12 override-padding counter_task-list">
                            <MenteeTaskList
                                :itemLength="focusedHeading.tasks.length" 
                                :allItems="focusedHeading.tasks"
                                :menteeId="menteeId"
                                :tasklistId="tasklistId"
                                :subTaskId="focusedSubtask.id"
                                :headingId="focusedHeading.id"
                                :searchText="searchText"
                                originFrom="focused">
                            </MenteeTaskList>
                            <div style="clear: both;"></div>
                          </div>
                        </b-collapse>
                      </div>
                    </div>
                    <div class="col-md-12 override-padding counter_task-list task-wrapper">
                      <MenteeTaskList
                          :itemLength="focusedSubtask.tasks.length" 
                          :allItems="focusedSubtask.tasks"
                          :menteeId="menteeId"
                          :tasklistId="tasklistId"
                          :subTaskId="focusedSubtask.id"
                          headingId=""
                          :searchText="searchText"
                          originFrom="focused">
                      </MenteeTaskList>
                    </div>
                    <div style="clear: both;"></div>
                  </b-card>
                </b-collapse>


              </div>
            </div>
          </div>
        </div>

    <!-- end of Focused Section display -->

          <div class="section-title" v-if="focusedSubtasks.length > 0 && tasklists_focus_loading == false">
            Remaining Sections
          </div>
          <div class="section-title" v-else-if="tasklists_focus_loading == false && focusedSubtasks.length == 0 && searchText != ''">
            Remaining Sections
          </div>
          <div class="section-title" v-else-if="tasklists_focus_loading == false && focusedSubtasks.length == 0">
            Full Sections
          </div>


          <div class="heading-seperator" style="margin-top: 0;"></div>
          <div v-show="tasklists_loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <div v-if="subtasks.length > 0">
            <div class="col-md-12 counter_subtask-list" id="tasks">              
              <div v-for = "(subtask, stindex) in subtasks">
                <div class="subtask-wrapper" style="margin-bottom: 10px;">
                <h4 class="panel-title">
                  <div class="col-12 p-0 float-left">
                    <div class="float-left col-4 p-0">
                      <b-link
                        v-b-toggle="'collapse-' + subtask.id" @click="getSecondFontIcon(subtask.id)" style="min-height: 44px;"
                        >
                          {{ subtask.name }}
                      </b-link>
                    </div>
                    <div class="float-left col-6" style="text-align: left; padding: 0px 0px 0px 0px;" v-if="subtask.id != 99999">
                      <b-link
                        v-b-toggle="'collapse-' + subtask.id" @click="getSecondFontIcon(subtask.id)" style="height: 44px; float: left; width: 100%;"
                        >
                      <div class="float-left progress p-0" style="margin-right: 20px;">
                        <div class="progress-bar-green" :style="'width: ' + subtask.subtaskCompetentPercent + '%;'" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <div class="float-left col-2 p-0 progress-text" >{{ subtask.subtaskCompetentPercent }}%</div>
                      </b-link>
                    </div>
                    <div class="float-left col-6 p-0" v-if="subtask.id == 99999" style="padding: 7px 10px 10px 20px  !important;">
                      <button class="btn btn-primary btn-sm dbAddRepsBtn1" @click="openAddOtherTasksModal('full')">
                        Add Tasks
                    </button>
                    </div>
                    <div class="float-left col-1 p-0" style="text-align: right !important; padding: 0px 0px 0px 0px !important; " >
                      <b-link
                        v-b-toggle="'collapse-' + subtask.id" class="p-0" @click="getSecondFontIcon(subtask.id)" v-if="selectedSubtask != '' && subtask.id == selectedSubtask && clickedFrom=='full'" style="padding: 10px !important; height: 44px;">                      
                        <i class="fa fa-angle-up angle-class" :id="'angle-'+ subtask.id" aria-hidden="true" ></i>
                      </b-link>

                      <b-link
                        v-b-toggle="'collapse-' + subtask.id" class="p-0" @click="getSecondFontIcon(subtask.id)" style="padding: 10px !important; height: 44px;" v-else>                      
                        <i class="fa fa-angle-down angle-class" :id="'angle-'+ subtask.id" aria-hidden="true" ></i>
                      </b-link>

                    </div>

                    <div class="float-right col-1 p-0 star-class" v-if="subtask.id != 99999 && subtask.focusedSectionId == ''">
                      <i class="fa fa-star-o"  aria-hidden="true"  @click="updateFocusedSection(subtask.id)" data-toggle="tooltip" data-placement="bottom" title="Add to Focused Section" style="cursor: pointer; opacity: 0.6;"></i>
                    </div>
                    <div class="float-right col-1 p-0 star-class"  v-if="subtask.id != 99999 && subtask.focusedSectionId != ''">
                      <i class="fa fa-star"  aria-hidden="true"  @click="removeFocusedSection(subtask.focusedSectionId)" data-toggle="tooltip" data-placement="bottom" title="Remove from Focused Section" style="cursor: pointer; color: #ee4200;"></i>
                    </div>
                    </div>
                    <div style="clear: both;"></div>

                </h4>

                <b-collapse v-bind:id="'collapse-' + subtask.id" class="mt-2 subtask-wrapper" visible v-if="selectedSubtask != '' && subtask.id == selectedSubtask && clickedFrom=='full'">                
                  <b-card>
                    <div class="col-md-12 override-padding counter_heading-list">
                      <div v-for = "(heading, index) in subtask.headings">
                        <b-link v-b-toggle="'collapse-' + subtask.id + '-' + heading.id"  variant="primary" size="sm" class="sub-heading" @click="getFontIcon(subtask.id + '-' + heading.id)" v-if="selectedHeading != '' && heading.id == selectedHeading && clickedFrom=='full'">
                          {{ heading.name }}
                          <i class="fa fa-angle-up" :id="'angle-'+ subtask.id + '-' + heading.id" aria-hidden="true"></i>
                        </b-link>

                        <b-link v-b-toggle="'collapse-' + subtask.id + '-' + heading.id"  variant="primary" size="sm" class="sub-heading" @click="getFontIcon(subtask.id + '-' + heading.id)" v-else>
                          {{ heading.name }}
                          <i class="fa fa-angle-down" :id="'angle-'+ subtask.id + '-' + heading.id" aria-hidden="true"></i>
                        </b-link>

                        <b-collapse v-bind:id="'collapse-' + subtask.id + '-' + heading.id" class="mt-2 task-wrapper" visible v-if="selectedHeading != '' && heading.id == selectedHeading && clickedFrom=='full'">
                          <div class="col-md-12 override-padding counter_task-list">
                            <MenteeTaskList
                                :itemLength="heading.tasks.length" 
                                :allItems="heading.tasks"
                                :menteeId="menteeId"
                                :tasklistId="tasklistId"
                                :subTaskId="subtask.id"
                                :headingId="heading.id"
                                :searchText="searchText"
                                originFrom="full">
                            </MenteeTaskList>
                            <div style="clear: both;"></div>
                          </div>
                        </b-collapse>

                        <b-collapse v-bind:id="'collapse-' + subtask.id + '-' + heading.id" class="mt-2 task-wrapper" v-else>
                          <div class="col-md-12 override-padding counter_task-list">
                            <MenteeTaskList
                                :itemLength="heading.tasks.length" 
                                :allItems="heading.tasks"
                                :menteeId="menteeId"
                                :tasklistId="tasklistId"
                                :subTaskId="subtask.id"
                                :headingId="heading.id"
                                :searchText="searchText"
                                originFrom="full">
                            </MenteeTaskList>
                            <div style="clear: both;"></div>
                          </div>
                        </b-collapse>
                      </div>
                    </div>
                    <div class="col-md-12 override-padding counter_task-list task-wrapper">
                      <MenteeTaskList
                          :itemLength="subtask.tasks.length" 
                          :allItems="subtask.tasks"
                          :menteeId="menteeId"
                          :tasklistId="tasklistId"
                          :subTaskId="subtask.id"
                          :searchText="searchText"
                          headingId=""
                          originFrom="full">
                      </MenteeTaskList>
                    </div>
                    <div style="clear: both;"></div>
                  </b-card>
                </b-collapse>

                <b-collapse v-bind:id="'collapse-' + subtask.id" class="mt-2 subtask-wrapper" v-else>
                  <b-card>
                    <div class="col-md-12 override-padding counter_heading-list">
                      <div v-for = "(heading, index) in subtask.headings">
                        <b-link v-b-toggle="'collapse-' + subtask.id + '-' + heading.id"  variant="primary" size="sm" class="sub-heading" @click="getFontIcon(subtask.id + '-' + heading.id)">
                          {{ heading.name }}
                          <i class="fa fa-angle-down" :id="'angle-'+ subtask.id + '-' + heading.id" aria-hidden="true"></i>
                        </b-link>
                        <b-collapse v-bind:id="'collapse-' + subtask.id + '-' + heading.id" class="mt-2 task-wrapper">
                          <div class="col-md-12 override-padding counter_task-list">
                            <MenteeTaskList
                                :itemLength="heading.tasks.length" 
                                :allItems="heading.tasks"
                                :menteeId="menteeId"
                                :tasklistId="tasklistId"
                                :subTaskId="subtask.id"
                                :headingId="heading.id"
                                :searchText="searchText"
                                originFrom="full">
                            </MenteeTaskList>
                            <div style="clear: both;"></div>
                          </div>
                        </b-collapse>
                      </div>
                    </div>
                    <div class="col-md-12 override-padding counter_task-list task-wrapper">
                      <MenteeTaskList
                          :itemLength="subtask.tasks.length" 
                          :allItems="subtask.tasks"
                          :menteeId="menteeId"
                          :tasklistId="tasklistId"
                          :subTaskId="subtask.id"
                          :searchText="searchText"
                          headingId=""
                          originFrom="full">
                      </MenteeTaskList>
                    </div>
                    <div style="clear: both;"></div>
                  </b-card>
                </b-collapse>                

              </div>
            </div>
          </div>
        </div>
        <div v-else-if="tasklists_loading == false" class="noitems-custom-msg" style="font-style: italic; margin-top: 20px;">No tasklist assigned</div>
      </div>
      <ReviewRepetition
          :isModalVisible="isReviewRepsModalVisible"
          :menteeId="menteeId"
          :tasklistId="tasklistId"
          ref="review_reps_form"
          @close="isReviewRepsModalVisible = false">
      </ReviewRepetition>
      <AddOtherTasks 
        :isModalVisible="isAddTasksModalVisible"
        :menteeId="menteeId"
        :tasklistId="tasklistId"
        :subTaskId="99999"
        :searchText="searchText"
        :originFrom="originFrom"

        ref="add_other_tasks"
        @close="isAddTasksModalVisible = false"
      >

    </AddOtherTasks>

    </div>
  </div>
  </div>
</div>
</template>

<script>
import router from '../../router/index';
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import custommodal from './custom_modal.vue';
import axios from 'axios';
import moment from 'moment';
import { store } from '../../store/store.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import MenteeTaskList from './mentee_task_list.vue';
import ReviewRepetition from './ReviewRepetition.vue';
import AddOtherTasks from '../manager/AddOtherTasksModal.vue';

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});

export default {
  data: function () {
    return {
      'subtasks': [],
      isModalVisible: false,
      'history_title': '',
      'history_comment': '',
       loading: false,
       tasklists: [],
       tasklistId: '',
       menteeId: '',
       subTaskId: '',
       menteeName: '',
      'assessment_loading': false,
      tasklists_loading: false,
      tasklists_focus_loading: false,
      repCount: 0,
      isReviewRepsModalVisible: false,
      isManager: false,
      pageTitle: '',
      program: '',
      userType: '',
      userTypeName: '',
      searchText: '',
      isAddTasksModalVisible: false,
      focusedSubtasks: [],
      searchTextFlag: false,
      selectedSubtask: '',
      selectedHeading: '',
      clickedFrom: '',
      originFrom: '',
    }
  },
  computed:
  {


  },
  methods: {
    onchangeTasklists: function() {
      this.showAssessmentofTasklist();
      this.showFocusedSectionOfMentee();
    },
    openAddOtherTasksModal: function(arg) {
      this.$refs.add_other_tasks.verrors.clear();
      this.isAddTasksModalVisible = true;
      this.originFrom = arg;
    },
    clearText() {
      this.searchText = '';
      this.subtasks = [];
      this.focusedSubtasks = [];
      this.tasklists_loading = true;
      this.tasklists_focus_loading = true;
      this.searchTextFlag = false;
      var navigatePath = this.$router.currentRoute.path;
      navigatePath += '?e4=' + this.tasklistId;
      this.$router.push(navigatePath)
      this.$router.go();
    },
    dovalidate() {
      var flag = 1;
      if(this.searchText == '') {
        alert("Please enter search text");
        flag = 0;
        return false;
      }
      if(this.searchText.length < 3) {
        alert("Search text should be minimum 3 characters");
        flag = 0;
        return false;
      }
      return flag;
    },
  dosearch() {
    var flag = this.dovalidate();
    if(flag == 1) {
     this.searchTextFlag = true;
     this.subtasks = [];
     this.focusedSubtasks = [];
     this.tasklists_loading = true;
     this.tasklists_focus_loading = true;
     axios.get('/desktop/mentees_tasklists_search/' + this.menteeId + '/' + this.tasklistId + '/' + this.$store.state.user_accountid, {
        params: {
          searchText: this.searchText,
        }
      })
      .then(response =>  {
        this.loading = false;
        this.tasklists_loading = false;
        this.tasklists_focus_loading = false;
        this.subtasks = response.data.subtasks;
        this.focusedSubtasks = response.data.focusSubtasks;
        this.repCount = response.data.rep_count;
        console.log(this.focusedSubtasks);
      })
      .catch(function(error) {

      });
    }
      
  },  
  showAssessmentofTasklist() {
     this.tasklists_loading = true;
     this.subtasks = [];
     axios.get('/desktop/mentees_tasklists_detail/' + this.menteeId + '/' + this.tasklistId + '/' + this.$store.state.user_accountid)
      .then(response =>  {
          this.tasklists_loading = false;
          this.subtasks = response.data.subtasks;
          this.repCount = response.data.rep_count;
      })
      .catch(function(error) {

      });
  },
  menteeRepititionApproval() {
    this.isReviewRepsModalVisible = true;
    const vmessage = 'hide_vmessage';
    this.$refs.review_reps_form.getMenteeRepetitionList();
    this.$refs.review_reps_form.getPendingReviews(this.repCount);
    this.$refs.review_reps_form.getScoreLists(vmessage);
  },
  getFontIcon(id) {
    if (document.getElementById('collapse-' + id).style.display == "") {
      document.getElementById('angle-'+ id).className = "fa fa-angle-down";
    } else {
      document.getElementById('angle-'+ id).className = "fa fa-angle-up";
    }
  },
  getSecondFontIcon(id) {
    if (document.getElementById('collapse-' + id).style.display == "") {
      document.getElementById('angle-'+ id).className = "fa fa-angle-down angle-class";
    } else {
      document.getElementById('angle-'+ id).className = "fa fa-angle-up angle-class";
    }
  },  
  redirectTaskGoal() {
    router.push('/mentees-task-goals/' + this.menteeId + '?e4=' + this.tasklistId);
  },
  IsUserManager() {
    var roles = this.$store.state.roles;
    if(roles.indexOf('ROLE_ADMIN') > -1)
    {
      return true;
    }
    else {
      return false;
    }
  },
  updateFocusedSection(subtaskId) {
       axios('/mentee/focusedsection/insert',
        {
          method: 'POST',
          data: {            
            mentee_id: this.menteeId,
            tasklist_id: this.tasklistId,
            heading_id: subtaskId,          
            account_id: this.$store.state.user_accountid,
          },
        })
        .then(() => {          
          this.flash({ message: 'Focused section added successfully', variant: 'success' });
          var navigatePath = this.$router.currentRoute.path;
          navigatePath += '?e4=' + this.tasklistId;
          this.$router.push(navigatePath)
          this.$router.go();
        })
        .catch((error) => {
           
        });
  },
  removeFocusedSection(focusedSectionId) {
        axios('/mentee/focusedsection/remove/' + focusedSectionId,
              {
                method: 'DELETE',
              }
          )
          .then((resp) => {
              this.flash({ message: 'Focused section removed successfully', variant: 'success' });
              var navigatePath = this.$router.currentRoute.path;
              navigatePath += '?e4=' + this.tasklistId;
              this.$router.push(navigatePath)
              this.$router.go();
           })
           .catch(error => {

            });
  },  
  showFocusedSectionOfMentee() {
     this.focusedSubtasks = [];
     this.tasklists_focus_loading = true;
     axios.get('/mentee/focusedsection/' + this.menteeId + '/' + this.tasklistId + '/' + this.$store.state.user_accountid)
      .then(response =>  {          
          this.focusedSubtasks = response.data.subtasks;        
          this.tasklists_focus_loading = false; 
      })
      .catch(function(error) {

      });
  },
  getFocusedFontIcon(id) {
    if (document.getElementById('collapse-focused-' + id).style.display == "") {
      document.getElementById('angle-focused-'+ id).className = "fa fa-angle-down";
    } else {
      document.getElementById('angle-focused-'+ id).className = "fa fa-angle-up";
    }
  },
  getFocusedSecondFontIcon(id) {
    if (document.getElementById('collapse-focused-' + id).style.display == "") {
      document.getElementById('angle-focused-'+ id).className = "fa fa-angle-down angle-class";
    } else {
      document.getElementById('angle-focused-'+ id).className = "fa fa-angle-up angle-class";
    }
  },
  },
  components: {
    UserMenu,
    GoBack,
    custommodal,
    AdminSidebarMenu,
    MenteeTaskList,
    ReviewRepetition,
    AddOtherTasks,
  },
  created: function () {    
    this.isManager = this.IsUserManager();
    this.loading = true;
    this.tasklists_loading = true;
    this.tasklists_focus_loading = true;
    this.menteeId = this.$route.params.mentee_id;
    
      
      axios('/desktop/user-account-info/'+this.menteeId+'/'+this.$store.state.user_accountid,
      {
        method: 'GET',
      })
      .then(response => {
        this.program = response.data.program;
        this.menteeName = response.data.user_name;
        this.userType = response.data.user_type;
        
        if (this.userType == "apprentice") {
          this.pageTitle = "Apprentice Assessment";
          this.userTypeName = "Apprentice";
        } else {
          this.pageTitle = "Mentee's Assessment";
          this.userTypeName = "Mentee";
        }

        axios.get('/desktop/mentees_tasklists', {
          params: {
            mentee_id: this.menteeId,
            account_id: this.$store.state.user_accountid
          }
        })
        .then(response =>  {
          this.loading = false;
          var tasklistArr = response.data;
          this.tasklistId = tasklistArr[0]['id'];
          for( var i=0; i< tasklistArr.length; i++) {
            var tasklistOption = {value:tasklistArr[i]['id'], text:tasklistArr[i]['name']};
            this.tasklists.push(tasklistOption);
          }

          var e4_val = this.$route.query.e4;
          if(typeof(e4_val) !==  "undefined") {
              this.tasklistId = e4_val;
          }

          var e6_val = this.$route.query.e6;
          if(e6_val) {
            this.searchText = e6_val;
            this.dosearch();
          }
          else {
            this.showAssessmentofTasklist();
            this.showFocusedSectionOfMentee();
          }
        })
        .catch(function(error) {

        });

      })
      .catch(() => {
      });

    var roles = store.state.roles;
    if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
      this.admin = true;
    }
    
    this.selectedSubtask = this.$route.query.e1;
    this.selectedHeading = this.$route.query.e2;
    this.clickedFrom = this.$route.query.e7;
  },

  updated() {
  /* setTimeout(()=>{
    var e1_val = this.$route.query.e1;
    var e2_val = this.$route.query.e2;
    var e3_val = this.$route.query.e3;
    var e6_val = this.$route.query.e6;
      if(e1_val) {
        var ele = document.getElementById("collapse-" + e1_val);
        ele.style.display = 'block';
        this.getSecondFontIcon(e1_val);
        var ele2 = ele.parentElement.getElementsByClassName("panel-title")[0].getElementsByTagName("a")[0];
        ele2.className = '';
        var ele1 = document.getElementById("collapse-" + e1_val + "-" + e2_val);
        ele1.style.display = 'block';
        if(e2_val) {
          this.getFontIcon(e1_val + '-' + e2_val);
        }
        document.getElementById(e3_val).scrollIntoView(false);
      }
   }, 300);  */
  },

}
</script>

<style scoped>
.menteeName {
  text-decoration: underline !important;
  text-transform: capitalize;
  padding-top: 6px;
  color: #002F42 !important;
}
.progress {
  margin-top: 3px;
  border: 1px solid #DEEBDF;
  background-color: #FFFFFF;
  height: 15px;
  width: 167px;
}
.progress-blue {
  height: 10px;
}
.progress-bar-green {
  background-color: #228B22;
}
.progress-bar-blue {
  background-color: #29A3E4;
}
.back-btn-wrapper {
  width:100%;
  margin-left: 10px;
  margin-right: 0px;
}
.mentee_name {
  font-size: 19px;
  margin-bottom: 0px;
}
hr {
  margin: 10px auto;
}
.custom_hr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin: 10px 0px;
  width: 100%;
}
.goReview{
  background-color: #FFF;
  border: 1px solid #00acee;
  border-radius: 10px;
  padding: 3px 1px 3px 3px;
  line-height: 15px;  
  float: left;
  width: 100%;
  margin-left: 10px;
}
@media (max-width: 1360px) {
  .goReview {
    width: 100%;
    padding: 3px 1px 3px 0px;
  }
  .goReview-0 {
    width: 60%;
  }
  .goReviewBtn {
    width: 26%;
  }
}
@media (min-width: 1361px) {
  .goReview {
    width: 95%;
  }
  .goReview-0 {
    width: 70%;
  }
  .goReviewBtn {
    width: 33%;
  }
}
@media (min-width: 1680px) {
  .goReviewBtn {
    width: 40%;
  }
}

.goReview div {
  margin-left: 2px;
  float: left;
}
.review_count { 
  color: #00acee; 
  font-size: 24px; 
  margin-top: 6px; 
}
.review_text { 
  font-weight: 100;
  color: #002F42;
  padding-left: 2px;
  font-size: 12px;
}
.goRepsBtn, .goRepsBtn:active {
  color: #FFF; 
  background-color: #EE4200 !important;
  border: 1px solid #EE4200 !important;
  border-radius: 10px;
  padding: 2px 5px;
  margin-top: 3px;
  height: 25px;
}
.manageBtn, .manageBtn:active, .manageBtn:focus {
  color: #00acee !important;
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 10px;
  width: 120px;
  margin-left: 10px;
}
.task-goal-btn {
  color: #00acee !important;
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  font-size: 13px;
  font-weight: 900;
  padding: 8px;
  width: 100%;
  border-radius: 10px;
}
.search-tasks {
  border-left: none;
  border-right: none;
  border-top: none;
  width: 90%;
  margin-top: 10px;
  background-color: #e9e9e9 !important;
  border-bottom: 1px solid #002F42;
  outline: none;
}
/* Small Devices */
@media (min-width: 320px) and (max-width: 576px) { 
  .goReview {
    float: left;
    margin-left: 16px;
  }
}
/* Iphone 5 */
@media (min-width: 320px) and (max-width: 576px) { 
  .manageBtn {
    width: 60px;
  }
}
@media (min-width: 375px) and (max-width: 601px) { 
  .manageBtn {
    width: 109px;
  }
}
/* Ipad */
@media (min-width: 768px) and (max-width: 1024px) { 
  .manageBtn {
    width: 89px;
  }
}
.dbAddRepsBtn1, .dbAddRepsBtn1:active, .dbAddRepsBtn1:focus {
  color: #FFF !important;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 5px 10px;
  line-height: 10px;
  width: 167px;
}
.focused-section-highlight {
  margin-bottom: 10px !important; 
  border: 2px solid #002f42 !important;
  border-radius: 5px;
}
.star-class {
  text-align: right !important;
  padding: 10px 30px 10px 20px !important;
}
.clear-button {
  width: 80px;
  border-radius: 10px;
}
.search-icon {
  color: #002F42;
  font-size:25px;
  margin-left: -26px;
  cursor: pointer;  
}
.section-title {
  color: #5799C7;
  font-weight: bold;
  margin-top: 10px
}
.progress-text {
  text-align: left;
  font-weight: normal;
  font-size: 13px;
  margin-top: 3px;  
}
.angle-class {
  color: #40A5EB;
  font-size:20px;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/mentees_task.vue